var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DateTime } from 'luxon';
import { getDrillTypeNameFromId, isDrillTypeId } from "../utils/Drill";
var Work = /** @class */ (function () {
    function Work(props) {
        /** 教科書出版社設定で設定されていない出版社のコースを使用しているか？ */
        this.unavailableCourse = false;
        this.id = props.id;
        this.creatorId = props.creatorId;
        this.creatorName = props.creatorName;
        this.drillType = props.drillType;
        this.courseId = props.courseId;
        this.workType = props.workType;
        this.name = props.name;
        this.createdDatetime = props.createdDatetime;
        this.updatedDatetime = props.updatedDatetime;
        this.hiddenHint = props.hiddenHint;
        this.fiscalYear = props.fiscalYear;
        this.available = props.available;
    }
    Work.fromApi = function (props) {
        return new Work(__assign(__assign({}, props), { drillType: isDrillTypeId(props.drillType) ? getDrillTypeNameFromId(props.drillType) : '', createdDatetime: DateTime.fromISO(props.createDateTime), updatedDatetime: props.updateDateTime ? DateTime.fromISO(props.updateDateTime) : undefined }));
    };
    // 呼び出し元から渡されたオブジェクトをダイアログ用に初期化する
    Work.fromCallback = function (props) {
        return new Work(props);
    };
    Object.defineProperty(Work.prototype, "getWorkForCallback", {
        // 呼び出し元に返すためのオブジェクト
        get: function () {
            return __assign({}, this);
        },
        enumerable: false,
        configurable: true
    });
    // 教科書出版社設定の変更により利用できない出版社(コース)をワークが使用していると発覚したときに叩く関数
    Work.prototype.changeUnavailableCourse = function () {
        this.unavailableCourse = true;
    };
    return Work;
}());
export { Work };
